import React from "react";
import {RouteComponentProps} from "react-router-dom";

import {Spinner} from "../../atoms/spinner";
import {DocumentTitle} from "../../atoms/document-title";
import {Banner} from "../../atoms/banner";
import {useQuicksightCurrentUserDashboards} from "./hooks/useQuicksightCurrentUserDashboards";
import {ReportQuicksightDashboard} from "./reports/ReportQuicksightDashboard";
import {ReportingLayout} from "./reporting-layout";

export const PageReportingDashboards = ({location}: RouteComponentProps) => {
  const {data, isFetched} = useQuicksightCurrentUserDashboards();

  const dashboard = data?.find(item => location.hash.endsWith(item.id));

  return (
    <ReportingLayout isActionRowVisible={false}>
      <DocumentTitle title="Reside - Admin - Reporting | Dashboards" />
      {!isFetched ? (
        <Spinner />
      ) : !dashboard ? (
        <Banner title="No reports are available for this section.">
          <p>Please choose a different report from the left menu.</p>
        </Banner>
      ) : (
        <ReportQuicksightDashboard id={dashboard.id} name={dashboard.name} />
      )}
    </ReportingLayout>
  );
};
